import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - ALERT (GLASS) EXTRA ||============================== //
// Complementa o override base de Alert com o visual glassmorphism usado no tema.

export default function AlertGlass(theme: Theme) {
  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          backgroundColor: `${theme.palette.background.paper} !important`,
          backgroundImage: 'none !important',
          color: `${theme.palette.text.primary} !important`,
          backdropFilter: 'blur(10px) saturate(120%)',
          WebkitBackdropFilter: 'blur(10px) saturate(120%)',
          border: '1px solid rgba(255,255,255,.08)',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
        }
      }
    }
  };
}

